'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _uniq2 = require('lodash/uniq');

var _uniq3 = _interopRequireDefault(_uniq2);

var _getChildren = require('./get-children');

var _getChildren2 = _interopRequireDefault(_getChildren);

var _getParents = require('./get-parents');

var _getParents2 = _interopRequireDefault(_getParents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function searchTree() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$idField = _ref.idField,
      idField = _ref$idField === undefined ? 'id' : _ref$idField,
      _ref$parentField = _ref.parentField,
      parentField = _ref$parentField === undefined ? 'parent' : _ref$parentField,
      operation = _ref.operation;

  if (!operation) {
    throw new Error('tree.search - Missing operation!');
  }

  return function (rows) {
    var _ref2;

    // Track fetched parents to get them into the results only once
    var fetchedParents = {};

    return (0, _uniq3.default)((_ref2 = []).concat.apply(_ref2, _toConsumableArray(operation(rows).map(function (row) {
      var rowParent = row[parentField];

      if (fetchedParents[rowParent]) {
        return row;
      }

      fetchedParents[rowParent] = true;

      var children = (0, _getChildren2.default)({ index: row._index, idField: idField, parentField: parentField })(rows);
      var parents = (0, _getParents2.default)({ index: row._index, idField: idField, parentField: parentField })(rows);

      return parents.concat(row).concat(children);
    }).filter(function (a) {
      return a;
    }))));
  };
}

exports.default = searchTree;